import { CurrencyConversionTransactionResponse, CurrencyConversionTransactionRequest } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export default function useFetchCurrencyConversionTransaction({ bearer }: { bearer?: string }) {
  const [fetching, setFetching] = useState(false);

  const [currencyConversionTransaction, setCurrencyConversionTransaction] =
    useState<CurrencyConversionTransactionResponse>();

  async function fetchCurrencyConversionTransaction(params: CurrencyConversionTransactionRequest) {
    try {
      setFetching(true);
      const res = await api.fetchCurrencyConversionTransaction(params, bearer);
      if (!res.Success) throw new Error(res.ErrorMessage);
      setCurrencyConversionTransaction(res);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, currencyConversionTransaction, fetchCurrencyConversionTransaction };
}
